const runtimeConfig = window.__SAPI_CONFIG__ || {};

function resolveRuntimeValue(key, fallback = "") {
  return runtimeConfig[key] || process.env[key] || fallback;
}

export const apiRoot =
  resolveRuntimeValue("VUE_APP_API_ROOT", "http://localhost:3000");

export const apiGraficos =
  resolveRuntimeValue("VUE_APP_API_GRAFICOS", "http://localhost:8000");

export const baseUrl =
  resolveRuntimeValue("VUE_APP_FRONT_URL", "http://localhost:8080");

export const firebaseAnalyticsEnabled =
  resolveRuntimeValue("VUE_APP_FIREBASE_ANALYTICS_ENABLED").trim().toLowerCase() === "true";

export const firebaseAnalyticsConfig = {
  apiKey: resolveRuntimeValue("VUE_APP_FIREBASE_API_KEY"),
  authDomain: resolveRuntimeValue("VUE_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: resolveRuntimeValue("VUE_APP_FIREBASE_PROJECT_ID"),
  storageBucket: resolveRuntimeValue("VUE_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: resolveRuntimeValue("VUE_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: resolveRuntimeValue("VUE_APP_FIREBASE_APP_ID"),
  measurementId: resolveRuntimeValue("VUE_APP_FIREBASE_MEASUREMENT_ID"),
};
